import { render } from "./LicenseHeaderSettings.vue?vue&type=template&id=3f561e82&scoped=true"
import script from "./LicenseHeaderSettings.vue?vue&type=script&lang=js"
export * from "./LicenseHeaderSettings.vue?vue&type=script&lang=js"

import "./LicenseHeaderSettings.vue?vue&type=style&index=0&id=3f561e82&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f561e82"]])

export default __exports__